<template>
  <div v-show="leagueType !== 'Supercup' || (leagueType === 'Supercup' && (!isOverviewPage || matches.length > 0))">
    <Transition name="fade" mode="out-in">
      <div v-show="!loading && rounds && Object.keys(rounds).length">
        <div ref="statsFilter" v-if="!['Cup', 'European Cup', 'National Cup', 'Supercup'].includes(leagueType)"
             class="static">
          <div class="bg-zt-bg-main-td border-b border-b-zt-light xl:border-b-0 xl:!shadow-none">
            <FootballStatsFilter class="bg-zt-light/35 pt-2.5 border-t border-x border-zt-light rounded-t-zt"
            :analytic-type="isOverviewPage ? 'league-overview-results' : 'league-results'"
            is-league-results
            :options="filteringOptions"
            @filtering-changed="(value, initial) => changeFilters(value, initial)"
            ref="filterComponent"/>
          </div>
        </div>
        <div class="border-t border-zt-light"
             :class="{'rounded-t-zt' : (leagueType === 'Cup' || leagueType === 'European Cup' || leagueType === 'National Cup' || leagueType === 'Supercup') && this.roundedTop}">
          <div v-for="(value, key, index) in roundsToShow" :key="key" class="flex flex-col items-start w-full">
            <div v-if="value.round_matches.length > 0" :class="{ 'rounded-t-zt' : ((leagueType === 'Cup' || leagueType === 'European Cup'
             || leagueType === 'National Cup' || leagueType === 'Supercup') && this.roundedTop) && index === 0 }"
                 class="flex border-x border-b border-zt-light gap-x-[7px] text-xs font-normal -leading-[0.18px]
                        bg-zt-light-full px-[15px] py-2.5 w-full">
              <div class="w-[15px] h-[11px] mt-[1px]">
                <img ref="CountryImg" class="w-full h-full rounded-[2px]" :src="countryFlag" :alt="countryName"
                     :class="{ 'translate-y-px' : countryName === 'Świat' }">
              </div>
              <span v-if="leagueId === 34 || leagueId === 32">
                El. Mistrzostw Świata ({{ leagueId === 34 ? 'Ameryka Poł.' : 'Europa' }}) - {{ cupRoundName(key, 0, 0, false) }}
              </span>
              <span v-else-if="leagueType === 'Cup'">
                {{ countryName.toUpperCase() }}: Puchar - {{ cupRoundName(key, 0, value.round_matches[0].matches_count_in_round ?? 0) }}
              </span>
              <span v-else-if="leagueType === 'European Cup' || leagueType === 'National Cup'">
                {{ leagueName }} - {{ cupRoundName(key, Number(leagueId)) }} {{ [2,3,848].includes(Number(leagueId)) && cupRoundName(key).includes('Play-offy') ? '- Finał' : '' }}
              </span>
              <span v-else class="whitespace-nowrap overflow-ellipsis overflow-hidden max-w-full">
                {{ countryName.toUpperCase() }}: {{ leagueName }} {{ getMatchRoundString(key) }}
              </span>

              <div v-if="selectedFilters[0] === 'halfs'" class="flex flex-nowrap ml-auto relative mr-[25px] gap-x-[17px] xl:mr-[21px]">
                <span :class="{'opacity-40': selectedFilters[1] === 'secondhalf'}">1p.</span>
                <div class="absolute left-1/2 h-6 -top-1 w-[1px] opacity-40 bg-white rounded-full"></div>
                <span :class="{'opacity-40': selectedFilters[1] === 'firsthalf'}">2p.</span>
              </div>
            </div>
            <div v-if="selectedFilters.length > 0 || leagueType === 'Cup' || leagueType === 'European Cup' || leagueType === 'Supercup' || leagueType === 'National Cup'"
                 v-for="(match, mIndex) of filterRoundMatches(value)" :key="match.match_id"
                 class="w-full">
              <FootballStatsListItem :redirect-to-h2h="match.is_h2h_available && leagueType !== 'Cup'"
                                     :show-promotion-icon="showPromotionIcon(match, key)"
                                     :current-filters="selectedFilters"
                                     :displaying-stat="displayingStat"
                                     :mark-winner="markWinner"
                                     :class="{ '!rounded-b-zt' : !expandVisible &&  Object.keys(roundsToShow).length - 1 === index && filterRoundMatches(value).length - 1 === mIndex}"
                                     :filtering-result="calculateFilterResult(match)"
                                     :match="match"
                                     :show-hour="shouldShowHour(match)"
                                     :show-double-match="false"
                                     :show-odds="selectedFilters[0] === '1x2' || selectedFilters[0] === '' || isLMLELKE ||
                                     [5,32,34].includes(leagueId) || selectedFilters.length === 0"
                                     show-date show-animation/>
            </div>
          </div>
          <div v-if="(noOfRounds > amount || (noOfDisplayedMatches && noOfMatches > noOfDisplayedMatches)) && !isOverviewPage"
               class="py-4 flex items-center rounded-b-zt border-b bg-zt-light/35 border-x border-zt-light justify-center
                      text-zt-more text-xs underline font-normal uppercase">
            <span class="cursor-pointer zt-hover" @click="amount += 2">Rozwiń</span>
          </div>
          <div v-else-if="singleMatchesAmount !== 0 && singleMatchesAmount < noOfMatches && noOfDisplayedMatches < noOfMatches"
               class="py-4 flex items-center rounded-b-zt border-b bg-zt-light/35 border-x border-zt-light justify-center
                      text-zt-more text-xs underline font-normal uppercase">
            <span class="cursor-pointer zt-hover" @click="singleMatchesAmount += 20">Rozwiń</span>
          </div>
          <div v-if="isOverviewPage && noOfRounds > 0 && leagueType !== 'Supercup'"
               class="py-4 flex items-center rounded-b-zt border-b bg-zt-light/35 border-x border-zt-light justify-center
                      text-zt-more text-xs font-normal">
            <a data-count-click="WIĘCEJ MECZÓW w PRZEGLĄDZIE LIGI (ostatnie mecze)" :href="moreMatchesLink"
               class="no-default-style cursor-pointer underline zt-hover"
               :class="{'pointer-events-none opacity-40 no-underline' : (noOfRounds < amount && (noOfDisplayedMatches && noOfMatches <= noOfDisplayedMatches))}">
              <span class="mr-[7px]">WIĘCEJ MECZÓW</span>
              <svg class="inline-block" xmlns="http://www.w3.org/2000/svg" width="17" height="14" viewBox="0 0 17 14" fill="none">
                <path d="M10.3722 13.255L16.0405 6.62748L10.3722 0L9.44646 1.08243L13.5556 5.86789L3.24219 5.86789L3.24219 7.38708L13.5556 7.38708L9.44646 12.1725L10.3722 13.255Z" fill="#93A3BA"/>
                <path d="M1.29932 5.86719H0L0 7.38638H1.29932L1.29932 5.86719Z" fill="#93A3BA"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </Transition>
    <Transition name="fade" mode="out-in">
      <div v-if="!rounds || (Object.keys(rounds).length === 0 && !loading && !isOverviewPage)">
        <p :class="{ '!rounded-t-[0px]' : !roundedTopInfo }"
            class="text-xs text-zt-more text-center border border-zt-light rounded-zt font-normal w-full -leading-[0.18px] bg-zt-light-full py-2.5">
          Brak meczów do wyświetlenia
        </p>
      </div>
    </Transition>
  </div>
</template>

<script>
import FootballStatsFilter from "../components/FootballStatsFilter.vue";
import utils_mixin from "../mixins/utils_mixin";
import FootballStatsListItem from "../components/blocks/FootballStatsListItem.vue";
import football_mixin from "../mixins/football_mixin";

export default {
	name: 'FootballLeagueResults',
	components: {FootballStatsListItem, FootballStatsFilter},
	mixins: [utils_mixin, football_mixin],
	inject: ['WP'],
  props: {
    extraLeagueId: Number,
    extraLeagueName: String,
    extraCountryName: String,
    extraCountryQueryName: String,
    extraMatchesAmount: Number,
    extraSeason: Number,
    extraLeagueType: String,
    placeholderName: String,
    roundedTop: {
      type: Boolean,
      default: true
    },
    roundedTopInfo: {
      type: Boolean,
      default: true
    },
    extraAmount: Number
  },
	data() {
		return {
			rounds: {},
			selectedFilters: [],
			filteringOptions: [
				{
					name: '1x2',
					value: '1x2',
					options: []
				},
				{
					name: 'Rożne',
					value: 'corners',
					options: [
						{
							name: 'Rezultat',
							value: 'result',
							options: []
						},
						{
							name: 'Over/Under',
							value: 'overunder',
							options: [
								{
									name: '7,5',
									value: 7.5,
									options: []
								},
								{
									name: '8,5',
									value: 8.5,
									options: []
								},
								{
									name: '9,5',
									value: 9.5,
									options: []
								},
								{
									name: '10,5',
									value: 10.5,
									options: []
								},
								{
									name: '11,5',
									value: 11.5,
									options: []
								},
								{
									name: '12,5',
									value: 12.5,
									options: []
								},
                {
                  name: 'All',
                  value: 'all',
                  analytic: {
                    text: 'Linie overów rożnych oraz kartek - ALL',
                    category: 'football'
                  },
                  options: []
                },
							]
						}
					]
				},
				{
					name: 'Kartki',
					value: 'cards',
					options: [
						{
							name: 'Żółte',
							value: 'yellowcards',
							options: [
								{
									name: 'Rezultat',
									value: 'result',
									options: []
								},
								{
									name: 'Over/Under',
									value: 'overunder',
									options: [
										{
											name: '1,5',
											value: 1.5,
											options: []
										},
										{
											name: '2,5',
											value: 2.5,
											options: []
										},
										{
											name: '3,5',
											value: 3.5,
											options: []
										},
										{
											name: '4,5',
											value: 4.5,
											options: []
										},
										{
											name: '5,5',
											value: 5.5,
											options: []
										},
                    {
                      name: 'All',
                      value: 'all',
                      analytic: {
                        text: 'Linie overów rożnych oraz kartek - ALL',
                        category: 'football'
                      },
                      options: []
                    },
									]
								}
							]
						},
            {
              name: 'Czerwone',
              value: 'redcards',
              options: [
                {
                  name: 'Rezultat',
                  value: 'result',
                  options: []
                },
                {
                  name: 'Over/Under',
                  value: 'overunder',
                  options: [
                    {
                      name: '0,5',
                      value: 0.5,
                      options: []
                    },
                  ]
                }
              ]
            },
					]
				},
				{
					name: 'BTTS',
					value: 'btts',
					options: []
				},
				{
					name: 'Over/under',
					value: 'overunder',
					options: [
						{
							name: '0,5',
							value: 0.5,
							options: []
						},
						{
							name: '1,5',
							value: 1.5,
							options: []
						},
						{
							name: '2,5',
							value: 2.5,
							options: []
						},
						{
							name: '3,5',
							value: 3.5,
							options: []
						},
						{
							name: '4,5',
							value: 4.5,
							options: []
						},
						{
							name: '5,5',
							value: 5.5,
							options: []
						},
            {
              name: 'All',
              value: 'all',
              analytic: {
                text: 'Linie overów rożnych oraz kartek - ALL',
                category: 'football'
              },
              options: []
            },
					]
				},
				{
					name: 'Połowy',
					value: 'halfs',
					options: [
						{
							name: '1. Połowa',
							value: 'firsthalf',
							options: []
						},
						{
							name: '2. Połowa',
							value: 'secondhalf',
							options: []
						},
					]
				},
				{
					name: 'Karne',
					value: 'penalty',
					options: [
						{
							name: 'Gole Z Karnych',
							value: 'inmatch',
							options: []
						},
					]
				},
			],
			amount: this.extraAmount ?? 4,
      singleMatchesAmount: +this.$attrs.matchesAmount ?? 0,
			loading: true
		}
	},
  computed: {
	  isLMLELKE() {
		  return [2, 3, 848].includes(+this.leagueId);
	  },
		expandVisible() {
			if (this.noOfRounds > this.amount || (this.noOfDisplayedMatches && this.noOfMatches > this.noOfDisplayedMatches) && !this.isOverviewPage) {
				return true;
			} else if (this.singleMatchesAmount !== 0 && this.singleMatchesAmount < this.noOfMatches && this.noOfDisplayedMatches < this.noOfMatches) {
				return true;
			} else if (this.isOverviewPage && this.noOfRounds > 0 && this.leagueType !== 'Supercup') {
				return true;
			}
			return false;
		},
    roundsToShow() {
      if (!this.loading) {
        if (Object.entries(this.rounds).length === 0) {
          return [];
        }
        let tempRounds = [];

        tempRounds = Object.entries(this.rounds).slice();

        let matchesCount = this.noOfDisplayedMatches ? this.noOfDisplayedMatches : this.singleMatchesAmount;

        if (matchesCount) {
          let lastRound = Object.fromEntries(
            tempRounds.slice(0, 1)
          );
          const roundName = Object.keys(lastRound)[0];
          let round = {};
          round[roundName] = {};
          round[roundName].round_matches = lastRound[roundName].round_matches.slice(0, matchesCount);
          let noMissingMatches = matchesCount - round[roundName].round_matches.length;
          if (!noMissingMatches > 0) {
            return round;
          }

          let noOfRounds = Object.keys(tempRounds).length;

          for (let i = 1; i < noOfRounds - 1; i++) {
            let nextRound = Object.fromEntries(
              tempRounds.slice(i, i + 1)
            );
            const nextRoundName = Object.keys(nextRound)[0];
            round[nextRoundName] = {};
            round[nextRoundName].round_matches = [...nextRound[nextRoundName].round_matches.slice(0, noMissingMatches)];
            noMissingMatches -= round[nextRoundName].round_matches.length;
            if (!noMissingMatches > 0) {
              return round;
            }
          }
        }
        if (this.isOverviewPage) {
          const nextFullRound = Object.fromEntries(
            tempRounds.slice(1, 2)
          );

          const round = Object.fromEntries(
            tempRounds.slice(0, 1)
          );

          if (Object.keys(nextFullRound).length === 0) {
            return round;
          }

          const roundName = Object.keys(round)[0];
          const nextRoundName = Object.keys(nextFullRound)[0];

          const roundMatches = round[roundName].round_matches.length;

          if (roundMatches === this.teams.length / 2) {
            return round;
          }

          const missingMatches = this.teams.length / 2 - roundMatches;
          round[nextRoundName] = {};
          if (missingMatches > 0) {
            round[nextRoundName].round_matches = [...nextFullRound[nextRoundName].round_matches.slice(0, missingMatches)];
          } else {
            round[nextRoundName].round_matches = [...nextFullRound[nextRoundName].round_matches];

          }

          return round;

        }
        return Object.fromEntries(
          tempRounds.slice(0, this.amount)
        );
      }
    },
    noOfDisplayedMatches() {
      if (this.extraMatchesAmount) {
        return this.extraMatchesAmount;
      }
      return +this.$attrs.noOfDisplayedMatches || false;
    },
    leagueType() {
      if (this.extraLeagueType) {
        return this.extraLeagueType;
      }
      return this.$attrs.leagueType || 'league';
    },
    isOverviewPage() {
      if (!this.$attrs.isOverview) {
        return false;
      }
      return this.$attrs.isOverview === 'true';
    },
    teams() {
      if (!this.$attrs.teams) {
        return [];
      }
      if (this.isOverviewPage) {
        return JSON.parse(this.$attrs.teams);
      }
      return [];
    },
    noOfRounds() {
      return Object.keys(this.rounds).length
    },
    matches() {
      if (this.rounds) {
        return Object.values(this.rounds).flatMap(round => round.round_matches);
      }
      return [];
    },
    noOfMatches() {
      return this.matches.length;
    },
    markWinner() {
      if (this.leagueType === 'league') {
        return !(this.selectedFilters[0] !== '1x2' && this.selectedFilters[0] !== 'odds');
      }
      return true;
    },
    displayingStat() {
      if (this.selectedFilters[0] === 'corners') {
        return 'corners';
      }
      if (this.selectedFilters[0] === 'cards') {
        return 'cards';
      }
      if (this.selectedFilters[0] === 'penalty') {
        return 'penalty';
      }
      if (this.selectedFilters[0] === 'halfs') {
        return this.selectedFilters[1] === 'firsthalf' ? 'firsthalf' : 'secondhalf'
      }
      return 'goals';
    },
    leagueId() {
      if (this.extraLeagueId) {
        return this.extraLeagueId;
      }
      return +this.$attrs.leagueId;
    },
    leagueName() {
      if (this.extraLeagueName) {
        return this.extraLeagueName;
      }
      return this.$attrs.leagueName;
    },
    countryName() {
      if (this.extraCountryName) {
        return this.extraCountryName;
      }
      return this.$attrs.countryName;
    },
    countryQueryName() {
      if (this.extraCountryQueryName) {
        return this.extraCountryQueryName;
      }
      return this.$attrs.countryQueryName;
    },
    countryFlag() {
      return `/wp-content/themes/zawodtyper/assets/images/kraje/${this.countryQueryName.toLowerCase()}.svg`;
    },
    season() {
      if (this.extraSeason) {
        return this.extraSeason;
      }
      return this.$attrs.season ?? null;
    },
    defaultFilter() {
      return this.$attrs.filterButton;
    },
    moreMatchesLink() {
      const filterStr = this.selectedFilters.join(',');
      return `wyniki/?filter=${filterStr}`;
    },
  },
	mounted() {
    window.history.replaceState(null, '',
      `${window.location.href.substring(0, window.location.href.indexOf('?'))}`);
		this.getLeagueMatches();
    if (webSocketsEnabled) {
      this.addWSListeners();
    }
	},
	methods: {
    shouldShowHour(match) {
      // const isTournament = this.leagueType === 'European Cup' || this.leagueType === 'National Cup';

      const matchDate = DateTime.fromSQL(match.date).startOf('day');
      const today = DateTime.now().startOf('day');
      return today.diff(matchDate, 'days').days <= 1;
    },
    getLeagueMatches() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_get_league_matches',
          league_id: this.leagueId,
          season: this.season,
          status_array: ['FT', 'PEN', 'AET', '1H', 'HT', '2H', 'ET', 'BT', 'LIVE', 'WO'],
          qualification: this.$attrs.qualification ?? false
        })
        .then(response => {
          this.rounds = response.data.data;
          this.loading = false;
          this.$emit('loaded');
          this.removePlaceholder(this.$attrs.section ?? this.placeholderName);

          let totalMatches = 0;
          let matchesWithZeroCorners = 0;

          if (this.rounds) {
            Object.values(this.rounds).forEach((round) => {
              round.round_matches.forEach((match) => {
                totalMatches++;
                const corners = Number(match.localteam_corners) + Number(match.visitorteam_corners);
                if (corners === 0) {
                  matchesWithZeroCorners++;
                }
              });
            });

            const zeroCornersPercentage = (matchesWithZeroCorners / totalMatches) * 100;

            if (zeroCornersPercentage > 10) {
              const index = this.filteringOptions.findIndex(el => el.name === 'Rożne');
              if (index !== -1) {
                this.filteringOptions.splice(index, 1);
              }
            }
          }

          if (this.defaultFilter && this.defaultFilter !== '') {
            this.$refs.filterComponent.changeFilters(this.defaultFilter.split(','));
          }
        });
    },
		showPromotionIcon(match, round) {
			return (this.leagueType === 'Cup' || this.leagueType === 'Supercup' || ((this.leagueType === 'European Cup' || this.leagueType === 'National Cup')))
        && !round.includes('Group') && !round.includes('League') && !round.includes('3rd') && round !== 'Final'
				&& (match.double_match.is_double_match && match.double_match.match_no === 2 || !match.double_match.is_double_match);
		},
		changeFilters(value) {
      this.selectedFilters = value;
		},
		calculateFilterResult(match) {
			if (this.selectedFilters[0] === 'overunder') {
				const value = this.selectedFilters[1];
        const matchGoals = +match.localteam_goals + +match.visitorteam_goals - +match.localteam_et_goals - +match.visitorteam_et_goals;
        return matchGoals > value ? 'W' : 'P';
			}
			if (this.selectedFilters[0] === 'btts') {
        return +match.localteam_goals - +match.localteam_et_goals > 0 && +match.visitorteam_goals - +match.visitorteam_et_goals > 0 ? 'W' : 'P';
      }
			if (this.selectedFilters[0] === 'corners' && this.selectedFilters[1] === 'overunder') {
				const value = this.selectedFilters[2];
				const matchCorners = +match.localteam_corners + +match.visitorteam_corners;
				return matchCorners > value ? 'W' : 'P';
			}
			if (this.selectedFilters[0] === 'cards' && this.selectedFilters[2] === 'overunder') {
				const value = this.selectedFilters[3];
				const matchCards = this.selectedFilters[1] === 'yellowcards' ? +match.localteam_yellowcards + +match.visitorteam_yellowcards : +match.localteam_red_cards + +match.visitorteam_red_cards;
				return matchCards > value ? 'W' : 'P';
			}
			if (this.selectedFilters[0] === 'penalty') {
				return +match.localteam_penalties > 0 || +match.visitorteam_penalties > 0 ? 'W' : 'P';
			}
		},
    addWSListeners() {
      socket?.on('live-matches', data => {
        let filteredData = data.filter(el => {
          return Number(el.league_id) === Number(this.leagueId);
        });
        let flattenedRounds = Object.values(this.rounds).map(el => {
          return el.round_matches;
        });
        filteredData.forEach(match => {
          flattenedRounds.forEach(round => {
            let index = round.findIndex(el => {
              return Number(el.match_id) === Number(match.match_id);
            });
            if (index !== -1) {
              round[index].localteam_goals = match.localteam_goals;
              round[index].visitorteam_goals = match.visitorteam_goals;
              round[index].elapsed = match.elapsed;
              round[index].status = match.status;
              round[index].localteam_red_cards = match.localteam_red_cards;
              round[index].visitorteam_visitor_cards = match.visitorteam_visitor_cards;
            }
          })
        })
      });
    },
    filterRoundMatches(round) {
        return round.round_matches;
    },
	},
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;

}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>